module.exports = function anonymous(it
/**/) {
var out='<div class="fluid-video"> <iframe width="560" height="315" src="//www.youtube.com/embed/'+(it.YoutubeUrl)+'" frameborder="0" allowfullscreen></iframe><div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/youtubeEmbed.dot
 ** module id = 233
 ** module chunks = 0 1
 **/